module.exports = __webpack_public_path__ + "img/zq-icon.85df916b.svg";